import _export from '../internals/export.js';
import fails$1 from '../internals/fails.js';
import toObject$1 from '../internals/to-object.js';
import objectGetPrototypeOf from '../internals/object-get-prototype-of.js';
import correctPrototypeGetter from '../internals/correct-prototype-getter.js';

var $ = _export;
var fails = fails$1;
var toObject = toObject$1;
var nativeGetPrototypeOf = objectGetPrototypeOf;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var FAILS_ON_PRIMITIVES = fails(function () {
  nativeGetPrototypeOf(1);
}); // `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof

$({
  target: 'Object',
  stat: true,
  forced: FAILS_ON_PRIMITIVES,
  sham: !CORRECT_PROTOTYPE_GETTER
}, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});
